import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setToken } from '@/utils/tokenManager';
import logger from '../../utils/logger';

export const useAdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/admin/login`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      if (!response.ok) {
        let errorMessage = 'Login failed';
        try { const errorData = await response.json(); errorMessage = errorData.detail || errorMessage; }
        catch (err) { logger.error(err); errorMessage = response.statusText || errorMessage; }
        throw new Error(errorMessage);
      }
      let data;
      try { data = await response.json(); }
      catch (jsonError) { logger.error('JSON parse error:', jsonError); throw new Error('Invalid server response. Please try again.'); }
      if (data.token) setToken(data.token);
      navigate('/admin/dashboard');
    } catch (err) {
      logger.error('Login error:', err);
      setError(err.message || 'An unexpected error occurred');
    } finally { setLoading(false); }
  };

  return { email, setEmail, password, setPassword, showPassword, setShowPassword, error, loading, navigate, handleLogin };
};
